import { useLocation, useNavigate, useResolvedPath } from 'react-router';
import type { GenericSortListButtonProps } from './GenericSortListButton';
import { GenericSortListButton } from './GenericSortListButton';
import type { GenericSortableListProps } from './GenericSortListDialog';
import { GenericSortListDialog } from './GenericSortListDialog';

export type GenericSortListButtonAndDialogProps = Pick<
    GenericSortListButtonProps,
    'path'
> &
    Omit<GenericSortableListProps, 'open' | 'onClose'>;
export const GenericSortListButtonAndDialog = (
    props: GenericSortListButtonAndDialogProps,
) => {
    const { path, ...sortableListProps } = props;
    // not sure why, but useMatch(path) seems to be relative to the root, maybe a bug with v5-compat
    const location = useLocation();
    const resolvedPath = useResolvedPath('../' + path);
    const navigate = useNavigate();

    return (
        <>
            <GenericSortListButton path={path} />
            <GenericSortListDialog
                {...sortableListProps}
                open={location.pathname === resolvedPath.pathname}
                onClose={() => navigate('..')}
            />
        </>
    );
};
